export default __webpack_public_path__ + "static/media/aiSpeechActive.fa264ce0.svg";